import api from '../../../../../../../../api';

export const getStatisticalRelevanceForQuestions = async (
  questionResults,
  activeFilters,
  surveyId,
  viewToken
) => {
  const getQuestionStatisticalRelevance = async (
    question,
    answers,
    results
  ) => {
    const values = results.map(result => [result.answers.join()]);

    const levels = results.reduce((resultsMap, result) => {
      if (result && result.answers) {
        result.answers.map(answer => {
          if (resultsMap.indexOf(answer) === -1) {
            resultsMap.push(answer);
          }
          return null;
        });
      }
      return resultsMap;
    }, []);

    levels.sort((a, b) => a - b);

    const input = {
      Q004: {
        class: ['checkbox'],
        label: [question],
        label0: {},
        levels: levels.map(level => `${level}`),
        values
      }
    };

    return api().getAnalyticsData({ id: surveyId }, input, viewToken || null);
  };

  /*
    When active filtering only fetch statistical relevance for filtered responses
    As statistical relevance is only shown for these when there is active filtering
    When there is no filtering use unfiltered responses
  */

  const statisticalRelevanceRequests = questionResults.map(question =>
    getQuestionStatisticalRelevance(
      question.question,
      question.answers,
      activeFilters && activeFilters.length
        ? question.results
        : question.unfilteredResults
    )
  );

  const responses = await Promise.all(statisticalRelevanceRequests);

  return {
    responses
  };
};

export const parseStatisticalAnalysisData = (
  responses, // either unfiltered or filtered responses based on active filtering
  mergedGraphs,
  hiddenQuestions
) => {
  if (
    !mergedGraphs ||
    mergedGraphs.length === 0 ||
    !mergedGraphs[0].answers ||
    mergedGraphs[0].answers.length === 0
  )
    return {};

  const parsedStatisticsArray = [];

  if (responses) {
    const getStatisticalResponses = statResponses => {
      const groupArray = [];

      for (let j = 0; j < mergedGraphs[0].answers.length; j += 1) {
        if (!statResponses.json || !statResponses.json.data) {
          groupArray.push({
            min: null,
            max: null
          });
        }

        const answerValue =
          statResponses &&
          statResponses.json &&
          statResponses.json.data &&
          statResponses.json.data.find(value => value.alternative === `${j}`);

        if (answerValue) {
          groupArray.push({
            min: answerValue.lower,
            max: answerValue.upper
          });
        }

        if (!answerValue) {
          groupArray.push({
            min: null,
            max: null
          });
        }
      }

      return groupArray;
    };

    for (let i = 0; i < responses.length; i += 1) {
      if (responses && responses.length) {
        const statisticsGroup = getStatisticalResponses(responses[i]);

        if (statisticsGroup && statisticsGroup.length) {
          parsedStatisticsArray.push(statisticsGroup);
        }
      }
    }
  }

  const parsedStatistics = parsedStatisticsArray.reduce(
    (questionsMap, questionsArray, questionIndex) => {
      if (
        !(
          hiddenQuestions &&
          hiddenQuestions.length &&
          hiddenQuestions.indexOf(questionIndex) > -1
        )
      ) {
        const questionsMapStatistics = questionsMap;
        questionsMapStatistics[questionIndex] = questionsArray.reduce(
          (questionMap, question, questionAnswerIndex) => {
            const questionMapStatistics = questionMap;
            questionMapStatistics[questionAnswerIndex] = question;
            return questionMap;
          },
          {}
        );
      }

      return questionsMap;
    },
    {}
  );

  return parsedStatistics;
};
